import React, { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

import PropTypes from 'prop-types';
import { dateOnlySlashesFormat, formatUtcDate } from 'App/services/DateService';
import { appealReferralDetailsPropType } from './types';
import { ReviewSectionStyle } from 'App/components/EHR/styles';

const DefaultReviewContent = ({ appealReferralDetails, status, appealDocs }) => {
    const isStatusUpheld = status.toUpperCase() === 'UPHELD';
    const docKeys = useMemo(() => new Map(appealDocs?.map((doc) => [doc, uuidv4()])), [appealDocs]);
    return (
        <div>
            <ReviewSectionStyle>
                <strong>Referral Details (Appeals)</strong>
                <div>Status: {status}</div>
                <div>Upheld Prior Authorization to Appeal: {appealReferralDetails.paActivityId?.label || '--'} </div>
                <div>
                    Documents for appeals submission:
                    <ul>
                        {appealDocs?.map((doc) => (
                            <li key={docKeys.get(doc)}>{doc}</li>
                        ))}
                    </ul>
                </div>
                <div>
                    Appeal Submission Date:
                    {formatUtcDate({
                        date: appealReferralDetails.appealDate,
                        format: dateOnlySlashesFormat,
                    }) || '--'}
                </div>
                {isStatusUpheld && (
                    <div>
                        Create a follow-up Appeal Activity?{' '}
                        {appealReferralDetails.scheduleFollowupAppeal?.label || '--'}
                    </div>
                )}
            </ReviewSectionStyle>
            <ReviewSectionStyle>
                <strong>Notes</strong>
                <div>{appealReferralDetails.notes || '--'}</div>
            </ReviewSectionStyle>
        </div>
    );
};

DefaultReviewContent.propTypes = {
    status: PropTypes.string.isRequired,
    appealReferralDetails: appealReferralDetailsPropType.isRequired,
    appealDocs: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default DefaultReviewContent;
